const generateOffsetToXPositionInWeeks = () => {
  const weeksToXPosition = {
    0: 154, // 0 weeks, adjusted position to 154
  };
  for (let week = 1; week <= 37; week++) {
    // Calculate X position dynamically for each week
    weeksToXPosition[week * 604800] = 22 * week;
  }
  return weeksToXPosition;
};

const OffsetToXPositionInWeeks = generateOffsetToXPositionInWeeks();

export default OffsetToXPositionInWeeks;


// WEBPACK FOOTER //
// ./src/components/sitewide/OffsetToXPositionInWeeks.js